import { withCookies } from 'react-cookie/lib'
import LegalConsent from './LegalConsent'

export default withCookies(LegalConsent)
